import { ref } from 'vue'

import type { Ref } from 'vue'

import { useAuthApi } from '@features/auth'
import { useProfileStore } from '@entities/viewer'
import { useAdminRoutes } from '@shared/lib/routes'
import { AppRoute } from '@shared/config'

interface UserMenuReturn {
  refIsShown: Ref<boolean>
  setShown: (value: boolean) => void
  handleClickOutside: () => void
  setRedirectToProfile: () => Promise<void>
  setLogout: () => Promise<void>
}

export const useUserMenu = (): UserMenuReturn => {
  const refIsShown = ref<boolean>(false)
  const { logout } = useAuthApi()
  const profileStore = useProfileStore()

  const setShown = (value: boolean): void => {
    refIsShown.value = value
  }

  const handleClickOutside = (): void => {
    if (refIsShown.value) setShown(false)
  }

  const setRedirectToProfile = async (): Promise<void> => {
    setShown(false)
    const url = useAdminRoutes('admin.profile.edit')
    if (!url) return
    await navigateTo(url, { external: true })
  }

  const setLogout = async (): Promise<void> => {
    setShown(false)
    await logout({
      onSuccess: async () => {
        profileStore.clear()
        await navigateTo(AppRoute.Login)
      },
    })
  }

  return {
    refIsShown,
    setShown,
    handleClickOutside,
    setRedirectToProfile,
    setLogout,
  }
}
